const schema = {
  EN: {
    signin_username: 'Username is required',
    signin_password: 'Password is required',
  },
  TH: {},
};

export default schema;
